import React, { useMemo } from 'react'

import useI18n from 'hooks/useI18n'
import {
  SummaryCard,
  SummaryGrid,
  SummaryLabel,
  SummaryValue,
} from './styled'

export default function SummaryCards({ summary }) {
  const { t } = useI18n()
  const cards = useMemo(() => [
    { key: 'total', label: t('staff_essentials_invites_total'), value: summary.total },
    { key: 'active', label: t('staff_essentials_invites_active'), value: summary.active },
    { key: 'used', label: t('staff_essentials_invites_registrations'), value: summary.used },
    { key: 'remaining', label: t('staff_essentials_invites_remaining'), value: summary.remaining },
  ], [summary, t])

  return (
    <SummaryGrid>
      {cards.map(card => (
        <SummaryCard key={card.key}>
          <SummaryLabel>{card.label}</SummaryLabel>
          <SummaryValue>{card.value}</SummaryValue>
        </SummaryCard>
      ))}
    </SummaryGrid>
  )
}
